import { IConselhoPagedResponse } from "models/response/conselho-paged-response";

export interface ConselhoDetailsState {
  conselhoDetails: IConselhoPagedResponse | null;
  loading: boolean;
  error: string | null;
}

export const ACTION_TYPES = {
  setConselhoDetails: 'setConselhoDetails',
  setLoading: 'setLoading',
  setError: 'setError',
} as const;

type ActionType = keyof typeof ACTION_TYPES;

export interface ConselhoDetailsAction {
  type: ActionType;
  payload: any;
}

export const ConselhoDetailsReducer = (
  state: ConselhoDetailsState,
  action: ConselhoDetailsAction
): ConselhoDetailsState => {
  switch (action.type) {
    case ACTION_TYPES.setConselhoDetails:
      return { ...state, conselhoDetails: action.payload, error: null };
    case ACTION_TYPES.setLoading:
      return { ...state, loading: action.payload };
    case ACTION_TYPES.setError:
      return { ...state, error: action.payload, loading: false };
    default:
      return state;
  }
};
